import { useState } from 'react'

export function useData() {
  const [open, setOpen] = useState(false)

  return { open, setOpen }
}

export type UseData = ReturnType<typeof useData>
